import React from 'react'
import { useLocalLabels } from '@sentecacommerce-theme/lib'
import { BasketLabels } from '../../basket.props'
import { EmptyBasketAndWishlist } from '../../../Common/EmptyBasketAndWishlist'

export const EmptyBasket = () => {
  const labels = useLocalLabels<BasketLabels>()

  return (
    <EmptyBasketAndWishlist
      emptyBasketOrWishlistText={labels?.emptyBasketText}
      emptyBasketOrWishlistCallToAction={labels?.emptyBasketCallToAction}
    />
  )
}
